import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchNotificationCenterTemplateByIdArgs,
  FetchNotificationCenterTemplatesArgs,
} from '../api/types/notificationCenter.types';

import {
  fetchNotificationCenterTemplateById,
  fetchNotificationCenterTemplates,
} from '../api/notificationCenter.api';

export const notificationCenterQueryKeys = createQueryKeys(
  'notificationCenter',
  {
    fetchNotificationCenterTemplateById: ({
      id,
      organizationId,
    }: FetchNotificationCenterTemplateByIdArgs) => ({
      queryFn: () =>
        fetchNotificationCenterTemplateById({ id, organizationId }),
      queryKey: [organizationId, id],
    }),
    fetchNotificationCenterTemplates: ({
      filters,
      organizationId,
    }: FetchNotificationCenterTemplatesArgs) => ({
      queryFn: () =>
        fetchNotificationCenterTemplates({
          filters,
          organizationId,
        }),
      queryKey: [organizationId, filters],
    }),
  },
);
